// eslint-disable-next-line no-unused-vars
import { get, getInfo,postInfo, post } from '@/utils/apiBase.js';

// 获取项目高扣点费率状态
export const getProStatus = (option) => {
  return get('/apis/settlement_php/get_pro_status', option);
};
// 获取项目高扣点费率状态
export const getRateLog = (option) => {
  return get('/apis/settlement_php/rate_log', option);
};
// 确认费率
export const submitRateValue = (option) => {
  return get('/apis/settlement_php/submit_rate_value', option);
};
// cp结算管理
export const getManager = (option) => {
  return getInfo('/apis/settlement/md/manager', option);
};
// cp结算预览
export const mdPreview = (option) => {
  return getInfo('/apis/settlement/md/preview', option);
};
// 获取用户有效验证的银行卡列表----待迁移Java
export const validBankAccountList = (option) => {
  return getInfo('/apis/userauth/valid_bank_account_list', option);
};
// 确认结算单
export const mdAudit = (option) => {
  return post('/apis/settlement/md/audit', option);
};

// 查看打款凭证
export const mdProof = (option) => {
  return getInfo('/apis/settlement/md/proof', option);
};
// 项目异常项
export const mdPro_error = (option) => {
  return get('/apis/settlement/md/pro_error', option);
};
// 获取项目其他异常信息
export const getSettleExceptional = (option) => {
  return get('/apis/project/cp_admin/get_settle_exceptional', option);
};
export default {
  getProStatus,
  getRateLog,
  submitRateValue,
  getManager,
  mdPreview,
  validBankAccountList,
  mdAudit,
  mdProof,
  mdPro_error,
  getSettleExceptional
};
